<div class="ac-modal">
	<div class="header">
		<div class="text-align-center text-30-extra-bold padding-20" dcrHTMLKey="RISK_PROXY_DIALOG_TITLE">Review Risk Proxies</div>
	</div>
	<div class="content">
		<hl-proxy-list-overview [portfolios]="portfolios"></hl-proxy-list-overview>
	</div>
	<div class="actions footer clearfix">
		<button dz-button class="done-button margin-right-20 pull-right" (click)="close()">
			<span dcrHTMLKey="RISK_PROXY_DONE_BUTTON">Done</span>
		</button>
	</div>
</div>
